import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { breakpointsDictMap } from '../../../css/breakpoints';
import { resolveResponsiveRangeProps } from '../../../library/props/responsiveRangeProps';
import { Box } from '../Box/Box';
import * as styles from './Hidden.css';

const Hidden = _a => {
  var {
    children,
    above,
    below,
    print,
    inline,
    className
  } = _a,
      boxProps = __rest(_a, ["children", "above", "below", "print", "inline", "className"]);

  const hiddenOnPrint = Boolean(print);
  const rangeProps = resolveResponsiveRangeProps({
    above,
    below
  });
  const display = inline ? 'inline' : 'block';
  const responsiveDisplay = breakpointsDictMap(b => rangeProps[b] ? 'none' : display);
  return _jsx(Box, Object.assign({
    display: responsiveDisplay,
    className: [hiddenOnPrint ? styles.hiddenOnPrint : undefined, className],
    component: inline ? 'span' : 'div'
  }, boxProps, {
    children: children
  }));
};

export { Hidden };
//# sourceMappingURL=Hidden.js.map